export const PROVIDER_NUMBER_FIELDS = [
  { key: 'priority', label: 'Prioridade', min: 1, max: 100, hint: '1 é a maior prioridade.' },
  { key: 'maxResults', label: 'Máximo de resultados', min: 1, max: 200, hint: 'Limite por consulta, sujeito à cobertura da fonte.' },
  { key: 'timeoutSeconds', label: 'Tempo limite (segundos)', min: 5, max: 120, hint: 'Prazo máximo para cada consulta.' },
]

export function providerFields(provider) {
  return {
    enabled: provider.enabled,
    searchMode: provider.searchMode,
    automaticFullText: provider.automaticFullText,
    ...Object.fromEntries(PROVIDER_NUMBER_FIELDS.map(({ key }) => [key, String(provider[key] ?? '')])),
  }
}

export function providerFieldsChanged(provider, fields) {
  const saved = providerFields(provider)
  return Object.keys(saved).some((key) => saved[key] !== fields[key])
}

export function validateProviderFields(provider, fields) {
  const errors = {}
  for (const { key, label, min, max } of PROVIDER_NUMBER_FIELDS) {
    const raw = String(fields[key] ?? '').trim()
    if (!/^\d+$/.test(raw) || !Number.isSafeInteger(Number(raw)) || Number(raw) < min || Number(raw) > max)
      errors[key] = `${label}: informe um número inteiro de ${min} a ${max}.`
  }
  if (!['Automatic', 'Manual'].includes(fields.searchMode)) errors.searchMode = 'Selecione o modo de busca.'
  else if (fields.searchMode === 'Automatic' && !provider.supportsAutomaticSearch)
    errors.searchMode = 'Esta integração ainda não oferece busca automática.'
  if (typeof fields.enabled !== 'boolean') errors.enabled = 'Informe se a integração está ativa.'
  if (typeof fields.automaticFullText !== 'boolean' || (fields.automaticFullText && !provider.supportsAutomaticFullText))
    errors.automaticFullText = 'Esta integração ainda não oferece leitura automática do inteiro teor.'
  return errors
}

export function providerUpdatePayload(provider, fields) {
  if (Object.keys(validateProviderFields(provider, fields)).length)
    throw new Error('Revise os campos da integração antes de salvar.')
  return {
    version: provider.version,
    enabled: fields.enabled,
    searchMode: fields.searchMode,
    automaticFullText: fields.automaticFullText,
    ...Object.fromEntries(PROVIDER_NUMBER_FIELDS.map(({ key }) => [key, Number(fields[key])])),
  }
}

export function providerMutationError(result) {
  if (result.status === 409)
    return 'Esta integração foi alterada em outra sessão. Suas edições foram mantidas. Recarregue a configuração salva antes de editar novamente.'
  if (result.status === 503)
    return 'As configurações estão indisponíveis no momento. Suas edições foram mantidas. Tente novamente mais tarde.'
  if (result.status === 403) return 'Você não tem permissão para alterar as integrações de jurisprudência.'
  if (result.status === 400) return result.error || 'A configuração foi recusada. Revise os campos informados.'
  return result.error || 'Não foi possível salvar. Suas edições foram mantidas.'
}

export function officialProviderUrl(value) {
  try {
    const url = new URL(value)
    return url.protocol === 'https:' && !url.username && !url.password ? url.href : null
  } catch { return null }
}
